import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'

import Bubble from '../components/Bubble'
import IntroBox from '../components/IntroBox'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'
import FlickitySlider from '../components/FlickitySlider'

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="放眼天下" />

    <div
      className="bg-banner-30 bg-center bg-cover py-12 md:bg-center-x-42p lg:bg-center-x-45p xl:bg-center"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-global-links.jpg)` }}
      id="anchors-at-the-bay-oversees-the-world"
    >
      <div className="absolute inset-0 py-12">
        <div className="container">
          <div data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
            <Bubble className="w-full md:w-1/2"
              title="聚焦大灣區　放眼全天下"
              subtitle=""
            >
            </Bubble>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="section-1">
      <div className="container">
        <div className="flex flex-row flex-wrap -mx-2 mb-8" data-aos="fade-up" data-aos-delay={850}>
          <div className="box-p65 w-full md:w-2/5 mb-4">
            <div className="mx-2 absolute inset-0">
              <img src="/AnnualReport2017-2018/images/global-links/3.1.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full md:w-3/5" data-aos="fade-up" data-aos-delay={1050}>
            <Bubble className="mx-2 mb-4">
              <div className="text-sm md:text-base leading-relaxed text-justify">
                <p className="mb-4">為全面落實《深化粵港澳合作推進大灣區建設框架協議》，在澳門特區政府社會文化司主導下，旅遊學院聯同旅遊局、教育暨青年局、高等教育輔助辦公室三個政府部門及九所大專院校（澳門大學、澳門理工學院、澳門科技大學、澳門城市大學、聖若瑟大學、澳門保安部隊高等學校、澳門管理學院、澳門鏡湖護理學院、中西創新學院）組成“打造粵港澳大灣區旅遊教育培訓基地工作組”。</p>
                <p>工作組期望能達到五大目標，即以研究支持科學規劃，促進大灣區旅遊協同發展；利用大灣區旅遊教育資源，增加學生升學的流動性；提升青少年對大灣區整體發展的認識，深化對“一國兩制”的瞭解；提升大灣區旅遊業人力資源素質，增強大灣區整體旅遊競爭力；建設溝通機制，搭建區域及國際交流平台。</p>
              </div>
            </Bubble>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap -mx-2">
          <div className="w-full md:w-1/2 flex" data-aos="fade-right">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="中國“一帶一路”倡議對全球旅遊業的長遠啟示國際論壇"
              image="/images/global-links/3.1.2.jpg"
            >
              旅遊學院旅遊業研究暨科研中心與南開大學旅遊與服務學院於2018年4月20日合辦國際論壇，題為“中國‘一帶一路’倡議對全球旅遊業的長遠啟示”。是次論壇邀請到多位各地學者及專家出席，針對重大變革、機遇以及“一帶一路”倡議帶來的挑戰而影響全球旅遊業的課題作探討和互相交流，吸引逾150名人士出席參與。
            </IntroBox>
          </div>

          <div className="w-full md:w-1/2 flex mt-12 md:mt-0" data-aos="fade-left">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="大灣區專業培訓中心"
              image="/images/global-links/3.1.3.jpg"
            >
              旅遊學院致力成為大灣區內的旅遊教育培訓中心。在2017/18學年，旅遊學院提供多項培訓課程，旨在培養本地以及大灣區的旅遊人才。
            </IntroBox>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12">
      <div className="container">
        <h2 className="text-3xl md:text-4xl text-orange-500 text-center mb-2" data-aos="fade-down">大灣區旅遊研究合作論壇</h2>
        <div className="flex flex-row flex-wrap -mx-2">
          <div className="w-full mb-4 mt-8">
            <div className="inset-0" data-aos="fade-up">
              <img src="/AnnualReport2017-2018/images/global-links/3.2.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
            <div className="text-sm md:text-base leading-relaxed font-normal my-8 text-justify" data-aos="fade-up" data-aos-delay={200}>
              <p className="mb-4">旅遊學院旅遊業研究暨科研中心與中山大學旅遊學院、香港理工大學酒店及旅遊業管理學院於2018年5月8日合辦“大灣區旅遊研究合作論壇”。是次論壇的獨特之處在於其與參與者的專業性和互動性，為大灣區旅遊合作研究制定議程。 論壇為大灣區的酒店和旅遊政策制定者、行業主管和研究人員等，提供探討大灣區在長期旅遊發展中面臨的挑戰和機遇的機會，並辨識未來聯合旅遊研究優先課題的議程。</p>
              <p>論壇吸引約110名人士登記參與論壇，當中包括香港理工大學、中山大學及旅遊學院的代表和大灣區其他的高等院教學者和研究人員，另外更包括來自大灣區各地的政策制訂者、政府官員、社區持分者、智囊團和社團等多個代表。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-8 md:py-12">
      <FlickitySlider className="mb-8 md:mb-12">
        <div className="w-full md:w-1/2 p-4">
          <Testimonial
            title="中國內地導遊試前輔導課程"
            color="orange"
          >
            為協助本地居民融入大灣區，學院於2018年3月開辦“中國內地導遊試前輔導課程”。課程導師由珠海導遊服務中心委派，目的是為有意在內地當導遊的澳門居民提供中國內地導遊證考試的試前培訓。
          </Testimonial>
        </div>
        <div className="w-full md:w-1/2 p-4">
          <Testimonial
            title="培訓江門中高級旅遊人才"
            color="blue"
          >
            2018年6月，學院為江門市旅遊局、三區四市旅遊管理部門有關領導，江門職業技術學院、特色旅遊鎮街、旅遊鄉村的負責人、江門市旅遊行業協會和主要旅遊景區的負責人舉辦旅遊管理培訓課程，希望提升大灣區核心城市之一——江門市旅遊工作者的職業素質。
          </Testimonial>
        </div>
        <div className="w-full md:w-1/2 p-4">
          <Testimonial
            title="MORS走進大灣區"
            color="orange"
          >
            <p className="mb-4">建立於2001年的澳門職業技能認可基準（MORS），透過引入工種認可制度，提升澳門旅遊業人力資源的質素。</p>
            <p className="mb-4">2009年MORS開始走出澳門，並進入珠海第一職業中學校園，目前該校已有超過3,300名內地學生接受MORS培訓，該校透過基準對7個不同工種進行評核，包括調酒師、前堂代辦及行李員、客戶關係主任、前台代理，客房服務員，男侍應/女侍應（中餐廳服務）、男侍應/女侍應（西餐廳服務）和零售主任。</p>
            <p>於2015年，學院再將MORS引入南沙，與嶺東職業技術學校合作，至今已為該校進行了前堂服務員及調酒員技能評估。</p>
          </Testimonial>
        </div>
        <div className="w-full md:w-1/2 p-4">
          <Testimonial
            title="考取國家職業資格——茶藝師"
            color="blue"
          >
            旅遊學院致力不斷拓展培訓內容以及提升培訓層次，力求打造成更加優質的旅遊教育及培訓機構。2017年11月，學院透過與勞工事務局合作，邀請廣東省職業技能鑒定指導中心人員來澳，為初級茶藝師學員作國家職業資格試前輔導及考核，共吸引29人報考。
          </Testimonial>
        </div>
      </FlickitySlider>
    </div>
    <div className="bg-gray-200 py-8 md:py-12" id="strengthen-international-connection">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">國際網絡遍全球</h2>
        <div className="text-left mx-auto text-sm md:text-base mt-8 font-normal text-justify" data-aos="fade-up">
          <p className="mb-4">隨着社會發展迅速，在全球化浪潮之下，旅遊學院保持廣闊的國際化視野，在課程設置、科研等硬件配套都融入了國際化元素。</p>
          <p className="mb-4">旅遊學院匯聚世界各地的優秀人才，在濃厚的學習氣氛之下，可自由進行知識交流以及學術探討。學位課程學生在此可享受學院構建的國際化學習環境，對日後提高職場上競爭力大有裨益，同時也有助提升學院科研質量。</p>
          <p className="mb-4">與此同時，學院也建立了龐大的國際網絡，目前已與32個國家和地區的106所院校和旅遊機構建立了合作伙伴關係。每年，學院迎來不少海外學生和國際交換生，進一步推動校園國際化。</p>
          <p>同時，學院鼓勵學生積極參加各種海外實習和交流計劃，並為此提供獎學金。也鼓勵學生到海外參加學術會議、實地考察和文化交流課程等，支持學生全面發展。</p>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12" id="pillar-of-global-tourism-education">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">高端培訓領航者</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3 flex" data-aos="fade-right">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/global-links/3.3.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex mt-8 md:mt-0" data-aos="fade-left">
            <div className="text-left mx-auto text-sm md:text-base pt-4 lg:pt-0 lg:pl-8 font-normal text-justify">
              <p className="mb-4">旅遊學院世界旅遊教育及培訓中心（以下簡稱中心）於2017年11月29日至12月6日及2018年5月24日至31日，舉辦了兩個為期八天的“旅遊目的地推廣與旅遊發展能力建設”專業培訓課程。</p>
              <p className="mb-4">在2017年的培訓中，來自中國內地、斐濟共和國、澳門特別行政區、馬爾代夫共和國、巴布亞新幾內亞獨立國、薩摩亞獨立國及瓦努阿圖共和國的26名代表參加了是次課程。培訓課程以課堂授課、案例分析、簡報、經驗分享及參觀的形式進行。除了由旅遊學院教授及學者授課外，該課程亦邀請到前亞太旅遊協會（PATA）主席、Sanctuary Resorts創辦人Andrew Jones先生從行業角度分享他在可持續旅遊方面的經驗。此外，亞洲航空港澳地區行政總裁劉小媛女士及澳門貿易投資促進局代表亦應邀分享了他們在航空業、活動策劃及市場推廣領域上的經驗。學員更參觀了澳門歷史城區的世界遺產及數間大型酒店，了解澳門旅遊設施的規劃和管理。</p>
              <p className="mb-4">在2018年5月的培訓，也是中心第五次與聯合國世界旅遊組織合作舉辦培訓課程，19名來自“一帶一路”沿線國家及地區，包括中國內地、緬甸聯邦共和國和巴基斯坦伊斯蘭共和國以及澳門特別行政區及聯合國世界旅遊組織的代表參加是次課程。</p>
              <p>2018年3月，旅遊學院於與緬甸聯邦共和國飯店與旅遊部轄下的飯店與旅遊局培訓和教育部門簽署合作備忘錄，透過提升人力資源質素及加強雙方在旅遊教育和培訓上的合作，共同推動旅遊業可持續發展。10名來自緬甸聯邦共和國飯店與旅遊部轄下的飯店與旅遊局培訓和教育部門的官員均參加了是次培訓課程。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="an-exchange-platform-of-portuguese-speaking-countries">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">中葡旅遊培訓平台</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-2/3 flex">
            <div className="text-left mx-auto text-sm md:text-base md:pr-8 font-normal text-justify" data-aos="fade-right">
              <p className="mb-4">為配合澳門特區政府政策，學院加強與葡語國家合作，以助力推動澳門成為中國與葡語國家商貿合作服務平台。</p>
              <p className="mb-4">旅遊學院與里斯本大學於2017年11月24日合作舉辦名為“道德與旅遊規劃：澳門和葡萄牙之經驗分享”的公開講座，探討促進旅遊業快速增長的挑戰，以及在該領域發展更負責任和可持續的需求。</p>
              <p>同時，旅遊學院於2017/18年度舉辦多場工作坊，有關培訓於2018年3月至7月舉行，是遊學院連續第三年為葡語國家的旅遊部門政府人員舉行的培訓工作坊。來自安哥拉、佛得角、東帝汶、幾內亞比紹、莫桑比克及聖多美和普林西比等葡語國家的公務員來澳參加培訓課程。</p>
            </div>
          </div>
          <div className="w-full lg:w-1/3 flex mt-8 lg:mt-0" data-aos="fade-left">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/global-links/3.3.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-8 md:py-12">
      <div className="flex flex-row flex-wrap -mx-8 md:mb-12">
        <div className="w-1/2 md:w-1/2 mb-12">
          <div className="mx-8" data-aos="fade-up">
            <IllustrationBox
              number={5}
              image="/images/International-qualification-professional.gif"
              title="學位課程數量"
              text="學院獲葡萄牙萊里亞理工學院認可的學士學位課程數量，這意味學院有關課程的畢業生可更便捷地到歐盟國家升學及工作。"
              className="text-4xl"
              alignment="left"
            />
          </div>
        </div>
        <div className="w-1/2 md:w-1/2 mb-12">
          <div className="mx-8" data-aos="fade-up" data-aos-delay={150}>
            <IllustrationBox
              number={18}
              image="/images/nationality.gif"
              title="個國家和地區"
              text="作為世界領先的旅遊教育機構之一，學院擁有國際化的師資隊伍，多個國家和地區的學者與經驗豐富的本澳教學人員一起於學院任教。"
              className="text-4xl"
              alignment="left"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12">
      <div className="container">
        <div className="w-full p-4" data-aos="zoom-out">
          <Testimonial
            title="高級管理課程"
            color="orange"
          >
            <p className="mb-4">旅遊學院與全球領先旅遊院校合作，為旅遊服務業高級管理人員開辦短期高端培訓課程，系列課程涵蓋了行業的最新趨勢及動態。</p>
            <p className="mb-4">旅遊學院因應酒店管理最新的發展潮流，於2017/18學年舉辦了三個高級管理課程，其中一個課程與瑞士洛桑酒店管理學院共同舉辦，另外兩個課程則與美國康奈爾大學酒店管理學院合作。</p>
            <p>有關課程於2018年4月至10月舉行，旅遊學院邀請瑞士洛桑酒店管理學院洛桑酒店諮詢顧問機構高級顧問Olivier Verschelde先生、美國康奈爾大學酒店管理學院行政教育學院Michael Oshins 博士、美國康奈爾大學Bill Carroll博士作為特邀嘉賓，內容涵蓋餐飲業成功的概念與持續發展、領導與激勵乃至酒店收益管理等。</p>
          </Testimonial>
        </div>
        <div className="w-full p-4" data-aos="zoom-out" data-aos-delay={150}>
          <Testimonial
            title="拓闊海外視野"
            color="blue"
          >
            <p className="mb-4">旅遊學院不斷拓闊學生的視野，提高他們的學習水平，增加對外界的了解。學院教學人員帶領學生參與海外實地考察和交流項目，令學生們獲益匪淺。</p>
            <p className="mb-4">2017年10月15日至19日，在葉占雄教授及古紀瀅博士帶領下，20名修讀“旅遊服務管理”及“旅遊景點的開發與管理”科目的旅遊企業管理三年級學生前往馬來西亞，開展實地考察及學術交流活動。</p>
            <p className="mb-4">交通是支撐旅遊業發展的重要要素之一。2017年11月10日，古紀瀅博士帶領27位修讀客運管理的二年級學生前往香港航空地面服務有限公司進行實地考察，研究世界級機場樞紐的運作和管理。</p>
            <p className="mb-4">2018年1月29日至2月5日，沈毅孟博士帶領修讀文化遺產管理專題研究科目的文化遺產管理學位課程20位四年級學生，赴斯里蘭卡參加為期八天的實地考察活動。</p>
            <p>崔瑞希博士於2017年11月9至13日帶領20位修讀“奇趣旅遊”科目的旅遊企業管理四年級學生，前住泰國清邁作實地考察及學術交流。2018年4月30 至5月5日，她又帶領25名修讀“奇趣旅遊”科目的旅遊企業管理四年級學生於前住越南峴港作實地考察及學術交流。</p>
          </Testimonial>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12" id="the-44th-worldskills-competition">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">第44屆世界職業技能競賽</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-2/3 flex">
            <div className="text-left mx-auto text-sm md:text-base md:pr-8 font-normal text-justify" data-aos="fade-right">
              <p className="mb-4">第44屆世界職業技能競賽於2017年10月15日至18日在阿布達比舉行，該賽事每兩年在世界各地舉辦，目的是提升青年職業技能人士的形象及認可，以及推廣相關技能所帶來的經濟效益。</p>
              <p className="mb-4">應勞工事務局邀請，旅遊學院成為“第44屆世界職業技能競賽”培訓機構之一，比賽包括烹飪、糖藝/西點及餐廳服務共3個範疇。培訓團隊由學院廚藝管理學位課程主任甘馬克博士帶領黃燕妮博士（烹飪）、黃琬芝小姐及劉擇祥先生（糖藝/西點）以及奧偉立先生（餐廳服務）組成。</p>
              <p className="mb-4">經過兩輪篩選後，四名旅遊學院學生成功獲選成為澳門區代表，分別是廚藝管理畢業生張寶而（烹飪）、廚藝管理二年級學生吳玉珊（糖藝/西點）、會展及節目管理畢業生何瑋（餐廳服務）及文化遺產管理二年級學生阮依樺（澳門花藝協會培訓的花藝代表），他們與來自超過40個國家及地區的代表比賽，表現均非常優秀，尤以餐廳服務及花藝兩個項目更分別奪得卓越表現獎。</p>
              <p>所有艱苦訓練都得到了回報，參賽學生透過是次競賽，帶來更多的經驗和技能。他們變得更強大、更專注、更具社交性、靈活性及抗壓力。培訓教師團隊也在參與過程中受益匪淺，他們與學生一起學習，通過與其他國家專家的互動，交流技能、知識和文化，建立友誼和創造合作機會。所有專家都在激烈的比賽過程和評判工作上全情投入。</p>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-4 lg:mt-0" data-aos="fade-left">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/global-links/3.3.5.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
            <div className="inset-0 mt-4">
              <img src="/AnnualReport2017-2018/images/global-links/3.3.4.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12">
      <div className="container flex flex-wrap">
        <div className="w-full p-4 lg:w-1/3" data-aos="flip-left">
          <div className="inset-0">
            <img src="/AnnualReport2017-2018/images/global-links/3.3.6.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
          </div>
        </div>
        <div className="w-full p-4 lg:w-2/3" data-aos="zoom-out">
          <Testimonial
            title="於2017/18 學年簽署合作協議的院校："
            color="blue"
          >
            <p className="mt-4 mb-4">中國江門職業技術學院</p>
            <p className="mb-4">中國中山大學</p>
            <p className="mb-4">巴黎費朗迪，法國國立高等廚藝和酒店管理學院</p>
            <p className="mb-4">馬來西亞泰萊大學</p>
            <p className="mb-4">緬甸聯邦共和國酒店和旅遊部轄下的酒店及旅遊總局培訓及教育部門</p>
            <p>葡萄牙埃武拉大學</p>
          </Testimonial>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container flex flex-wrap">
        <div className="w-full py-4 px-2 md:w-1/3" data-aos="zoom-out">
          <Testimonial
            title="學術研究項目的夥伴院校："
            color="orange"
          >
            <p className="mb-4">中國中山大學</p>
            <p>香港理工大學酒店及旅遊業管理學院</p>
          </Testimonial>
        </div>
        <div className="w-full p-4 md:w-2/3" data-aos="zoom-out" data-aos-delay={150}>
          <Testimonial
            title="國際認證課程合作夥伴："
            color="orange"
          >
            <ul className="list-disc">
              <li>美國酒店業協會教育學院</li>
              <li>亞洲商品展示設計師協會</li>
              <li>法國布根地葡萄酒學校</li>
              <li>微軟Office專家</li>
              <li>City and Guilds</li>
              <li>美國教育測驗服務社</li>
              <li>法國巴黎Ferrandi廚藝學院</li>
              <li>國際航空運輸協會</li>
              <li>國際調酒師協會</li>
              <li>國際康體專才培訓學院</li>
              <li>ITEC</li>
              <li>法國藍帶廚藝學院</li>
              <li>培生LCCI</li>
              <li>法國PIVERDIE高等花藝設計學院</li>
              <li>日本清酒侍酒師協會</li>
              <li>Servsafe®</li>
              <li>歐洲精品咖啡協會</li>
              <li>雪利酒學會</li>
              <li>葡萄酒及烈酒教育信託</li>
              <li>Wines of Portugal</li>
            </ul>
          </Testimonial>
        </div>
      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12 md:bg-center-x-61p lg:bg-center"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-global-links-summar-school.jpg)` }}
    >
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="summar-school">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-blue-500 text-center mb-8 md:mb-12" data-aos="fade-down">暑期國際交流課程</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3" data-aos="fade-right">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/global-links/3.4.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
            <div className="inset-0 mt-4">
              <img src="/AnnualReport2017-2018/images/global-links/3.4.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex mt-8 lg:mt-0" data-aos="fade-left">
            <div className="text-left mx-auto text-sm md:text-base md:pl-12 font-normal text-justify">
              <p className="mb-4">旅遊學院具有豐富的國際網絡。不少學生也善用暑假時間，參加海外的短期課程，擴闊視野之餘，更可吸收更多與旅遊相關的知識。部分的課程由學院與國際院校和組織共同舉辦，學生於2017/18學年參加以下的暑期國際交流課程：</p>
              <ul className="list-disc">
                <li>
                  <strong>2018澳門大學生天津學習交流計劃</strong>
                  <br/>
                  中國天津　2018年6月7至21日
                </li>
                <li>
                  <strong>雲南財經大學“2018年港澳與內地高等學校師生交流計劃”–彩雲風情–雲南苗彝風情體驗</strong>
                  <br/>
                  中國雲南　2018年6月8至14日
                </li>
                <li>
                  <strong>深圳大學“2018年港澳與內地高等學校師生交流計劃”–中華傳統文化體驗營–書畫詩詞篇</strong>
                  <br/>
                  中國深圳　2018年6月9至15日
                </li>
                <li>
                  <strong>南京大學“2018年港澳與內地高等學校師生交流計劃”–澳蘇大學生陽光成長文化2018年交流營</strong>
                  <br/>
                  中國江蘇　2018年6月19至25日
                </li>
                <li>
                  <strong>旅遊目的地與旅客體驗行銷</strong>
                  <br/>
                  荷蘭布列達　2018年7月1至12日
                </li>
                <li>
                  <strong>葡萄牙旅遊、語言與文化之旅</strong>
                  <br/>
                  葡萄牙埃武拉　2018年7月1至14日
                </li>
                <li>
                  <strong>2018《美饌、葡萄酒及文化》暑期研習班</strong>
                  <br/>
                  葡萄牙塞圖巴爾　2018年7月1至15日
                </li>
                <li>
                  <strong>2018峴港大學經濟學院夏季交流課程</strong>
                  <br/>
                  越南峴港　2018年7月2至11日
                </li>
                <li>
                  <strong>粵港澳高校聯盟主辦，暨南大學承辦2018“嶺南情、南洋行”海上絲綢之路活動</strong>
                  <br/>
                  中國廣州、印尼巴淡　2018年7月22至29日
                </li>
                <li>
                  <strong>中山大學“2018年港澳與內地高等學校師生交流計劃”–中山大學第九屆粵港澳高校嶺南文化學術夏令營–《嶺南文化行》</strong>
                  <br/>
                  中國廣州、湖南　2018年8月17至24日
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
